<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Alertas y Notificaciones
          </v-card-title>

          <v-card-text>
            Las alertas estan divididas en dos categorías:
            <ul>
              <br />
              <li>
                <strong>
                  Alertas Nuevas:
                </strong>
                Aqui encontraras todas las alertas en orden chronológico de
                acuerdo a los parametros configurados.
              </li>
              <li>
                <strong>
                  Alertas Resueltas:
                </strong>
                Aqui encontraras las últimas 10 alertas que han sido resueltas.
              </li>
            </ul>
            <br />
            Para mover una alerta de Nueva a Resulta solo se necesita hacer
            click en la alerta deseada o puedes resolver todas con el botón.
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog = false">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12>
        <material-card color="light-green lighten-1">
          <div slot="header">
            <div class=" font-weight-light mb-2">
              Alertas y Notificaciones
            </div>
            <div class="category">
              {{ new Date().toLocaleString() }}
            </div>
          </div>

          <v-card-text>
            <v-layout row wrap>
              <v-flex md6 sm12>
                <h2 class="title">
                  <v-layout>
                    <v-flex>
                      Alertas Nuevas: (Total:
                      {{ `${$store.state.alerts.length}` }})
                    </v-flex>
                    <v-flex>
                      <v-btn
                        flat
                        small
                        color="primary"
                        class="resolve-all"
                        @click="resolveAll()"
                        >Resolver Todos ---></v-btn
                      >
                    </v-flex>
                  </v-layout>
                </h2>
                <div v-if="!$store.state.alerts.length > 0">
                  <h3 class="text-xs-center subtitle">
                    <br />
                    No Hay Notificaciones
                  </h3>
                  <p class="text-xs-center number">
                    0
                  </p>
                </div>
                <div v-for="(alert, i) in $store.state.alerts" :key="alert.id">
                  <div @click="close(alert, i)">
                    <material-notification
                      class="mb-3 notification"
                      color="warning"
                      icon="mdi-bell-plus"
                    >
                      <v-layout>
                        <v-flex md10 sm10>
                          <!-- {{ alert }} -->
                          <p>
                            {{ new Date(alert.createdDate).toLocaleString() }}
                          </p>
                          <p>
                            {{ alert.description }}
                          </p>
                        </v-flex>
                        <v-flex md2 sm2>
                          <v-btn flat v-on="on" @click="close(alert, i)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </material-notification>
                  </div>
                </div>
              </v-flex>

              <v-flex md6 sm12>
                <h2 class="title">Alertas Resueltas: (Últimas 10)</h2>
                <div v-if="!$store.state.alertsResolved.length > 0">
                  <h3 class="text-xs-center subtitle">
                    <br />
                    No Hay Notificaciones
                  </h3>
                  <p class="text-xs-center number">
                    0
                  </p>
                </div>

                <div
                  v-for="alert in $store.state.alertsResolved.slice(0, 10)"
                  :key="alert.id"
                >
                  <material-notification class="mb-3" color="success">
                    <v-layout>
                      <v-flex md10 sm10>
                        <!-- {{ alert }} -->
                        <p>
                          {{ new Date(alert.createdDate).toLocaleString() }}
                        </p>
                        <p>
                          {{ alert.description }}
                        </p>
                      </v-flex>
                      <v-flex md2 sm2> </v-flex>
                    </v-layout>
                  </material-notification>
                </div>

                <!-- <material-notification class="mb-3" color="warning" dismissible>
                  <strong>WARNING</strong> - This is a regular notification made
                  with `color="warning"`
                </material-notification> -->

                <!-- <material-notification class="mb-3" color="error" dismissible>
                  <strong>DANGER</strong> - This is a regular notification made
                  with `color="error"`
                </material-notification> -->

                <!-- <material-notification class="mb-3" color="purple" dismissible>
                  <strong>PRIMARY</strong> - This is a regular notification made
                  with `color="purple"`
                </material-notification> -->
              </v-flex>
            </v-layout>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axiosApi from "../axios-api";

export default {
  components: {},
  data: () => ({
    dialog: true,
    alerts: [],
    alertsResolved: [],
    shortAlertsResolved: [],
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
  }),
  mounted() {
    this.getAlerts();
  },
  methods: {
    getAlerts() {
      if (this.$store.state.alerts.length > 0) {
        this.alerts = this.$store.state.alerts;
        this.alerts.reverse();
      }

      if (this.$store.state.alertsResolved.length > 0) {
        this.alertsResolved = this.$store.state.alertsResolved;
        this.alertsResolved.reverse();
        this.shortAlertsResolved = this.alertsResolved.slice(0, 10);
        console.log(this.shortAlertsResolved);
      }
    },
    close(event, i) {
      axiosApi
        // .get(`https://listener.rabiahostal.com.mx/api/alert/alerts`, payload).then((response) => {
        .put(`/alert/${event.id}`)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            this.alerts.remove = function(index) {
              this.splice(index, 1);
            };
            this.alertsResolved.push(this.alerts[i]);
            this.alerts.remove(i);
          }
        });
    },
    resolveAll() {
      this.alerts.forEach(async (alert, i) => {
        await axiosApi.put(`/alert/${alert.id}`);
        if (i == this.alerts.length - 1) {
          this.updateAlerts();
        }
      });
    },
    updateAlerts() {
      // alert("test");
      let id = this.$store.state.subProjectsArr.find(
        (x) => x.name === this.$store.state.subProject
      ).id;

      this.$store.dispatch("getAlerts", id);
      this.$store.dispatch("getAlertsResolved", id);

      this.getAlerts();
    },
  },
};
</script>

<style scoped>
.title {
  color: rgba(106, 106, 106, 0.8);
}

.notification {
  cursor: pointer;
}

.notification:hover {
  opacity: 0.65;
}

.resolve-all {
  margin-top: 0%;
}

.subtitle {
  color: rgba(106, 106, 106, 0.8);
}

.number {
  font-size: 15rem !important;
  margin-top: -16%;
  color: rgba(106, 106, 106, 0.55);
}
</style>
